import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { Action, MetaReducer, StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromPresenterWidgets from './+state/presenter-widgets.reducer'
import { PresenterWidgetsEffects } from './+state/presenter-widgets.effects'
import { PresenterWidgetsFacade } from './+state/presenter-widgets.facade'
import { undoRedoMetaReducer } from './+state/undo-redo.meta-reducer'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromPresenterWidgets.PRESENTER_WIDGETS_FEATURE_KEY,
      fromPresenterWidgets.presenterWidgetsReducer,
      {
        metaReducers: [
          undoRedoMetaReducer({
            undoableActionTypes: [],
            historyLimit: 0,
          }) as unknown as MetaReducer<fromPresenterWidgets.PresenterWidgetsState, Action>,
        ],
      },
    ),
    EffectsModule.forFeature([PresenterWidgetsEffects]),
  ],
  providers: [PresenterWidgetsFacade],
})
export class GbDashboardPresenterDataAccessPresenterWidgetsTemplateModule {}
